import styled from "styled-components";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 54px;

  border-radius: 3.5px;
  border: 1px solid ${COLORS.BLACK_25};
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  && .MuiInputBase-root {
    width: 100%;
    padding: 10px 0 10px 15px;

    line-height: 24px;
  }
`;
